import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// svc-04 `/v1/responsibility-map*`. Types mirror @penn/shared-types
// ResponsibilityMap (kept local per the existing api/*.ts convention).

export interface ResponsibilityMap {
  /** mapping_id natural key (e.g. "Haeger__ASIA"). */
  id: string;
  responsibility: string;
  region: string;
  salesEmails: string[];
  engineeringEmails: string[];
}

export interface ResponsibilityMapList {
  data: ResponsibilityMap[];
  total: number;
}

export interface ResponsibilityMapOptions {
  responsibilities: string[];
  regions: string[];
}

export interface CreateResponsibilityMapBody {
  responsibility: string;
  region: string;
  salesEmails: string[];
  engineeringEmails: string[];
}

export type UpdateResponsibilityMapBody = Partial<CreateResponsibilityMapBody>;

const BASE = "/v1/responsibility-map";

/** GET /v1/responsibility-map — all active mappings. */
export async function listResponsibilityMap(): Promise<ResponsibilityMapList> {
  const res = await Api.get(BASE);
  return unwrap<ResponsibilityMapList>(res.data);
}

/** GET /v1/responsibility-map/options — dropdown sources. */
export async function getResponsibilityMapOptions(): Promise<ResponsibilityMapOptions> {
  const res = await Api.get(`${BASE}/options`);
  return unwrap<ResponsibilityMapOptions>(res.data);
}

/** GET /v1/responsibility-map/:id. */
export async function getResponsibilityMap(id: string): Promise<ResponsibilityMap> {
  const res = await Api.get(`${BASE}/${encodeURIComponent(id)}`);
  return unwrap<ResponsibilityMap>(res.data);
}

/** POST /v1/responsibility-map. */
export async function createResponsibilityMap(
  body: CreateResponsibilityMapBody,
): Promise<ResponsibilityMap> {
  const res = await Api.post(BASE, body);
  return unwrap<ResponsibilityMap>(res.data);
}

/** PATCH /v1/responsibility-map/:id. */
export async function updateResponsibilityMap(
  id: string,
  body: UpdateResponsibilityMapBody,
): Promise<ResponsibilityMap> {
  const res = await Api.patch(`${BASE}/${encodeURIComponent(id)}`, body);
  return unwrap<ResponsibilityMap>(res.data);
}

/** DELETE /v1/responsibility-map/:id (soft-delete). */
export async function deleteResponsibilityMap(id: string): Promise<void> {
  await Api.delete(`${BASE}/${encodeURIComponent(id)}`);
}
